const isSvg = input => {
    if (input === undefined || input === null) return false

    input = input.toString().trim()
    if (input.length === 0) return false

    const doc = new DOMParser().parseFromString(input, 'image/svg+xml')
    if (doc.getElementsByTagName('parsererror').length > 0) return false

    return doc.documentElement.localName === 'svg'
}

export default isSvg
